module.exports = {
    "dropzone": "mcad5f590b_dropzone",
    "activeDropzone": "mcad5f590b_activeDropzone",
    "dropzoneText": "mcad5f590b_dropzoneText"
};